// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lecture-reminder-notice {
  position: fixed;
  z-index: 10020;
  width: 19rem;
  padding: 0.9rem;
  border: 1px solid #bfdbfe;
  border-radius: 0.7rem;
  background: #ffffff;
  color: #1f2937;
  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.2);
  box-sizing: border-box;
}

.lecture-reminder-notice--right {
  transform: translateY(-50%);
}

.lecture-reminder-notice--above {
  transform: translateY(-100%);
}

.lecture-reminder-notice--right::after {
  content: '';
  position: absolute;
  right: 100%;
  top: 50%;
  width: 0;
  height: 0;
  transform: translateY(-50%);
  border: 0.45rem solid transparent;
  border-right-color: #bfdbfe;
}

.lecture-reminder-notice--above::after {
  content: '';
  position: absolute;
  left: 1.5rem;
  top: 100%;
  width: 0;
  height: 0;
  border: 0.45rem solid transparent;
  border-top-color: #bfdbfe;
}

.lecture-reminder-notice__close {
  position: absolute;
  top: 0.35rem;
  right: 0.35rem;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #9ca3af;
  cursor: pointer;
  transition: color 0.15s ease;
}

.lecture-reminder-notice__close:hover {
  color: #374151;
}

.lecture-reminder-notice__close svg {
  width: 1.1rem;
  height: 1.1rem;
}

.lecture-reminder-notice__message {
  display: flex;
  align-items: flex-start;
  gap: 0.7rem;
  padding-right: 1.15rem;
}

.lecture-reminder-notice__avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  overflow: hidden;
  border: 1px solid rgba(209, 213, 219, 0.95);
  border-radius: 999px;
  background: #ffffff;
}

.lecture-reminder-notice__avatar svg {
  display: block;
  width: 100%;
  height: 100%;
}

.lecture-reminder-notice__message strong {
  display: block;
  margin-bottom: 0.2rem;
  font-size: 0.84rem;
}

.lecture-reminder-notice__message p {
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.45;
}

.lecture-reminder-notice__settings-hint {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-top: 0.65rem;
  padding-top: 0.55rem;
  border-top: 1px solid rgba(59, 130, 246, 0.16);
  color: #4b5563;
  font-size: 0.66rem;
  line-height: 1.35;
}

.lecture-reminder-notice__settings-hint strong {
  margin-left: 0.25rem;
  color: #1d4ed8;
  font-weight: 700;
}

.lecture-reminder-notice--dark {
  border-color: #3b82f6;
  background: #172554;
  color: #dbeafe;
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.4);
}

.lecture-reminder-notice--dark.lecture-reminder-notice--right::after {
  border-right-color: #3b82f6;
}

.lecture-reminder-notice--dark.lecture-reminder-notice--above::after {
  border-top-color: #3b82f6;
}

.lecture-reminder-notice--dark .lecture-reminder-notice__close {
  color: #6b7280;
}

.lecture-reminder-notice--dark .lecture-reminder-notice__close:hover {
  color: #e5e7eb;
}

.lecture-reminder-notice--dark .lecture-reminder-notice__settings-hint {
  border-top-color: rgba(96, 165, 250, 0.18);
  color: #bfdbfe;
}

.lecture-reminder-notice--dark .lecture-reminder-notice__settings-hint strong {
  color: #93c5fd;
}

@media (max-width: 520px) {
  .lecture-reminder-notice {
    width: min(19rem, calc(100vw - 1.5rem));
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/sidebar/LectureReminderNotice.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,2CAA2C;EAC3C,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,8CAA8C;EAC9C,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF","sourcesContent":[".lecture-reminder-notice {\n  position: fixed;\n  z-index: 10020;\n  width: 19rem;\n  padding: 0.9rem;\n  border: 1px solid #bfdbfe;\n  border-radius: 0.7rem;\n  background: #ffffff;\n  color: #1f2937;\n  box-shadow: 0 14px 36px rgba(15, 23, 42, 0.2);\n  box-sizing: border-box;\n}\n\n.lecture-reminder-notice--right {\n  transform: translateY(-50%);\n}\n\n.lecture-reminder-notice--above {\n  transform: translateY(-100%);\n}\n\n.lecture-reminder-notice--right::after {\n  content: '';\n  position: absolute;\n  right: 100%;\n  top: 50%;\n  width: 0;\n  height: 0;\n  transform: translateY(-50%);\n  border: 0.45rem solid transparent;\n  border-right-color: #bfdbfe;\n}\n\n.lecture-reminder-notice--above::after {\n  content: '';\n  position: absolute;\n  left: 1.5rem;\n  top: 100%;\n  width: 0;\n  height: 0;\n  border: 0.45rem solid transparent;\n  border-top-color: #bfdbfe;\n}\n\n.lecture-reminder-notice__close {\n  position: absolute;\n  top: 0.35rem;\n  right: 0.35rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: #9ca3af;\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n.lecture-reminder-notice__close:hover {\n  color: #374151;\n}\n\n.lecture-reminder-notice__close svg {\n  width: 1.1rem;\n  height: 1.1rem;\n}\n\n.lecture-reminder-notice__message {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.7rem;\n  padding-right: 1.15rem;\n}\n\n.lecture-reminder-notice__avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 2rem;\n  width: 2rem;\n  height: 2rem;\n  overflow: hidden;\n  border: 1px solid rgba(209, 213, 219, 0.95);\n  border-radius: 999px;\n  background: #ffffff;\n}\n\n.lecture-reminder-notice__avatar svg {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n.lecture-reminder-notice__message strong {\n  display: block;\n  margin-bottom: 0.2rem;\n  font-size: 0.84rem;\n}\n\n.lecture-reminder-notice__message p {\n  margin: 0;\n  font-size: 0.76rem;\n  line-height: 1.45;\n}\n\n.lecture-reminder-notice__settings-hint {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-top: 0.65rem;\n  padding-top: 0.55rem;\n  border-top: 1px solid rgba(59, 130, 246, 0.16);\n  color: #4b5563;\n  font-size: 0.66rem;\n  line-height: 1.35;\n}\n\n.lecture-reminder-notice__settings-hint strong {\n  margin-left: 0.25rem;\n  color: #1d4ed8;\n  font-weight: 700;\n}\n\n.lecture-reminder-notice--dark {\n  border-color: #3b82f6;\n  background: #172554;\n  color: #dbeafe;\n  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.4);\n}\n\n.lecture-reminder-notice--dark.lecture-reminder-notice--right::after {\n  border-right-color: #3b82f6;\n}\n\n.lecture-reminder-notice--dark.lecture-reminder-notice--above::after {\n  border-top-color: #3b82f6;\n}\n\n.lecture-reminder-notice--dark .lecture-reminder-notice__close {\n  color: #6b7280;\n}\n\n.lecture-reminder-notice--dark .lecture-reminder-notice__close:hover {\n  color: #e5e7eb;\n}\n\n.lecture-reminder-notice--dark .lecture-reminder-notice__settings-hint {\n  border-top-color: rgba(96, 165, 250, 0.18);\n  color: #bfdbfe;\n}\n\n.lecture-reminder-notice--dark .lecture-reminder-notice__settings-hint strong {\n  color: #93c5fd;\n}\n\n@media (max-width: 520px) {\n  .lecture-reminder-notice {\n    width: min(19rem, calc(100vw - 1.5rem));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
